export default __webpack_public_path__ + "static/masthead-2-2f11f8df218a262bd4a9a2e5fd495094.png";